import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { x: "2", y: "6", width: "20", height: "8", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 14v7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 14v7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M17 3v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 3v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 14 2.3 6.3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14 6 7.7 7.7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8 6 8 8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Construction";
const Construction = memo(themed(Icon));
export {
  Construction
};
//# sourceMappingURL=construction.js.map
